export default {"src":"/_next/static/media/empty-star.70152174.svg","height":17,"width":17};